import productFiltersTypeOption from './productFiltersTypeOption.json'
import productFiltersTypeProduct from './productFiltersTypeProduct.json'
import productFiltersTypeTag from './productFiltersTypeTag.json'

// initial state
const state = {
  filtersActiveProductsPage: [
    ...productFiltersTypeOption,
    ...productFiltersTypeProduct,
    ...productFiltersTypeTag
  ],
  filtersActiveProductDetailPage: [
    ...productFiltersTypeOption
  ],
  productFilters: {
    all: [
      ...productFiltersTypeOption,
      ...productFiltersTypeProduct,
      ...productFiltersTypeTag
    ],
    options: productFiltersTypeOption,
    products: productFiltersTypeProduct,
    tags: productFiltersTypeTag
  }
}

export default {
  namespaced: true,
  state
}



// WEBPACK FOOTER //
// ./src/js/store/modules/mockData/index.js